module.exports = __webpack_public_path__ + "img/10.b0214ac4.png";